export const getNearestSunday = (startDate: Date | string) => {
  const date = new Date(startDate);
  if (date.getDay() === 0) {
    date.setDate(date.getDate() + 1);
  }
  date.setDate(date.getDate() + ((7 - date.getDay()) % 7));
  return new Date(date);
};

export const getWeekAfterStartDate = (startDate: Date | string) => {
  const date = new Date(startDate);
  date.setDate(date.getDate() + 6);
  return new Date(date);
};
